import { createContext } from 'react';

import type { ActivitySource, BookingOption } from '../types/Activity';
import type { Vendor } from '../types/Vendor';

type ActivityContextType = {
  source?: ActivitySource;
  hidden?: boolean;
  id?: string;
  vendor?: Vendor;
  bookingOptions?: BookingOption[];
  cancellationPolicy?: string;
};
export const ActivityContext = createContext<ActivityContextType>({});
